import {FormioBase} from "./formiobase";

export class Columns extends FormioBase {
  public inputType = "columns";
  public title = "Columns";
  public label = "";
  public icon = "fa fa-check-square";
  public columns: any;
  public schema: any = {
    title: "Columns",
    components: [{
      input: true,
      tree: true,
      columns: [
        {
          components: [],
        },
        {
          components: [],
        },
        {
          components: [],
        },
        {
          components: [],
        },
        ],
      tableView: true,
      label: "",
      key: undefined,
      protected: false,
      persistent: true,
      clearOnHide: true,
      type: "columns",
      inputType: "columns",
      tags: [],
      customClass: "ds-columns",
    }],
  };
}
